"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LayoutControls = exports.LayoutBox = exports.getLayoutContainerCSS = exports.LayoutMediaCSS = exports.LayoutDefaultColumnCSS = exports.getTypeStructureLayoutGridTemplate = exports.FORM_CONTROLS_GRID_AREA = void 0;
const styled_components_1 = __importStar(require("styled-components"));
exports.FORM_CONTROLS_GRID_AREA = "FORM_CONTROLS_GRID_AREA";
const getTypeStructureLayoutGridTemplate = (typeStructureLayout = "", topLevel = false) => {
    const hasTemplate = typeof typeStructureLayout === "string" &&
        !!typeStructureLayout.replace(/\s/g, () => "");
    if (hasTemplate) {
        const gridTemplateRows = typeStructureLayout
            .split("\n")
            .map((l) => l.trim())
            .filter((l) => !!l);
        const maxColCount = gridTemplateRows.reduce((acc, row) => {
            const colCount = row.split(" ").length;
            return Math.max(acc, colCount);
        }, 1);
        const rowsWithControls = topLevel
            ? [...gridTemplateRows, exports.FORM_CONTROLS_GRID_AREA]
            : gridTemplateRows;
        const filledGridTemplateRows = rowsWithControls.map((row) => {
            const existingCols = row.split(" ");
            const colCount = existingCols.length;
            const ratio = maxColCount / colCount;
            return existingCols
                .reduce((acc, c, ind) => {
                const intRatio = ind === existingCols.length - 1
                    ? Math.ceil(ratio)
                    : Math.floor(ratio);
                const newCols = new Array(intRatio).fill(c);
                return [...acc, ...newCols];
            }, [])
                .join(" ");
        });
        return filledGridTemplateRows.map((l) => `"${l}"`).join("\n");
    }
    else {
        return "";
    }
};
exports.getTypeStructureLayoutGridTemplate = getTypeStructureLayoutGridTemplate;
exports.LayoutDefaultColumnCSS = (0, styled_components_1.css) `
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
  width: 100%;
`;
exports.LayoutMediaCSS = (0, styled_components_1.css) `
  @media screen and (max-width: 768px) {
    ${exports.LayoutDefaultColumnCSS}
  }
`;
const getLayoutContainerCSS = ({ $isGrid = false, $gridTemplate, $gridArea, }) => (0, styled_components_1.css) `
  grid-area: ${$gridArea ? $gridArea : "auto"};
  display: ${$isGrid ? "grid" : "flex"};
  grid-template: ${$gridTemplate ? $gridTemplate : "auto"};
  gap: 1em;
  overflow: auto;

  ${!$gridTemplate ? exports.LayoutDefaultColumnCSS : ""}

  ${exports.LayoutMediaCSS}
`;
exports.getLayoutContainerCSS = getLayoutContainerCSS;
/**
 * @ignore
 * */
exports.LayoutBox = styled_components_1.default.div `
  ${(p) => (0, exports.getLayoutContainerCSS)(p)}
`;
/**
 * @ignore
 * */
exports.LayoutControls = styled_components_1.default.div `
  flex: 0 0 auto;
  display: flex;
  flex-direction: row;
  justify-content: stretch;
  align-items: center;
  gap: 1em;

  ${exports.LayoutMediaCSS}
`;
